import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { SubscriptionService } from '../services/subscription.service';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { displayErrorMessage } from 'src/app/theme/utils/util-functions';
import { NotificationService } from '../services/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from 'src/app/theme/components/popup/popup.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SharedDataService } from '../services/sharedata.service';
import { FeatureTagObject } from 'src/app/types/feature-tags';
@Component({
  selector: 'app-delivery-calendar',
  templateUrl: './delivery-calendar.component.html',
  styleUrls: ['./delivery-calendar.component.scss']
})
export class DeliveryCalendarComponent implements OnInit, OnDestroy {

  selected_date = null;
  selected_week = null;
  calendar_data_weeks = null;
  calendar_data_last = null;
  disable_prev = false;
  disable_next = false;
  showCalendarDates = true;
  previousUrl = null;
  subService;
  subUserAddressService;
  showCalendarUrls = [ 
    "/shop",
    // "/all-products",
    "/products",
    "/categories",
    "/cart",
    "/account/orders",
  ];
  userDetails = {};
  deliveryPreference = null;
  deliveryDate = null;
  addressSubcribe = false;
  isMobile: boolean;
  viewCalender:boolean = true
  featureTags: FeatureTagObject = <FeatureTagObject>{};

  constructor(
    public router:Router,
    private subscription :SubscriptionService, 
    private notification: NotificationService,
    private apiService: ApiService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    public sharedDataService: SharedDataService,
  ) {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
        this.isMobile = result.matches;
        if (this.isMobile==false) {
          this.viewCalender = true;    
        }
    });
   }
 

  ngOnInit() { 
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    if (this.isMobile) { //for mobile screen it will close
      this.viewCalender = false;
    }
   this.deliveryDate = sessionStorage.getItem('selected_delivery_date') ? sessionStorage.getItem('selected_delivery_date') : "";
    if(this.activatedRoute.snapshot['data']['user']['response']['status']===1){
      this.userDetails = this.activatedRoute.snapshot['data']['user']['response']['data']['users'];
      this.deliveryPreference = this.userDetails['delivery_preference'];
      this.deliveryDate = this.deliveryDate ? this.deliveryDate : this.activatedRoute.snapshot['data']['user']['response']['data']['delivery_date'] ? this.activatedRoute.snapshot['data']['user']['response']['data']['delivery_date'] : "";
      if (this.userDetails['delivery_preference'].toLowerCase() == "pickup") {
        this.deliveryPreference = this.userDetails['delivery_preference'];
      }
      this.deliveryDate = this.deliveryDate ? this.deliveryDate : sessionStorage.getItem('selected_delivery_date');
      this.setDeliveryDate(this.deliveryDate);
    } else {
      this.getUserDetails();
    }
    
    this.subUserAddressService = this.subscription.getUserAddressDetails().subscribe(data=>{
      if(Object.keys(data).length>0){
        this.userDetails = data; 
        this.deliveryDate = sessionStorage.getItem('selected_delivery_date') ? sessionStorage.getItem('selected_delivery_date') : "";
      }  
    });

    this.getDeliveryCalendarData();
    this.previousUrl = this.router.url;
    this.subService = this.subscription.getSubject().subscribe(data => {
      if(data['msg'] === "set delivery calendar order status"){
        this.setDeliveryCalendarOrderStatus(data['status']);
      }
    })
    this.showCalendar();
  }

  ngOnDestroy(): void {
    !!this.subService && this.subService.unsubscribe();
    !!this.subUserAddressService && this.subUserAddressService.unsubscribe();
  }

  deliveryPreferenceoDialog() {
    var address =  this.userDetails['address'];
    var city =  this.userDetails['city'];
    var county =  this.userDetails['county'];
    var state =  this.userDetails['state'];
    var zipcode =  this.userDetails['zipcode'];
    var pickupLocName ="";
    var deliveryDays = this.userDetails['delivery_day']!="undefined" && this.userDetails['delivery_day'] ? this.userDetails['delivery_day'] : "";
    var locationNotes = "";
    if (this.userDetails['delivery_preference'].toLowerCase() == "pickup") {
        address = this.userDetails['pickup_location_details']['address'];
        city = this.userDetails['pickup_location_details']['city'];
        county = this.userDetails['pickup_location_details']['county'];
        state = this.userDetails['pickup_location_details']['state'];
        pickupLocName = this.userDetails['pickup_location_details']['name'];
        zipcode = this.userDetails['pickup_location_details']['zipcode'];
        if(this.userDetails['pickup_location_details']['delivery_days']) {
          var deliveryDays_tmp = this.addressSubcribe ? this.userDetails['pickup_location_details']['delivery_days'] : JSON.parse(this.userDetails['pickup_location_details']['delivery_days']);
          deliveryDays = deliveryDays_tmp && deliveryDays_tmp.length > 0 ? deliveryDays_tmp.join(', ') : "";
        }
        locationNotes = this.userDetails['pickup_location_details']['location_notes'] ? this.userDetails['pickup_location_details']['location_notes'] : "";
      }
      
      var data = {
        msg: "Delivery Preference",
        deliveryPreference: this.userDetails['delivery_preference'],
        address: address,
        city: city,
        county: county,
        state: state,
        zipcode: zipcode,
        pickupLocName: pickupLocName, 
        deliveryDays: deliveryDays,
        locationNotes: locationNotes,
      };
      
      data['formatted_address'] = this.userDetails['formatted_address'];
      
    const dialogRef = this.dialog.open(PopupComponent, {
      maxWidth: '90vw',
      data: data
    });
    // dialogRef.afterClosed().subscribe(result => {
    //   if(result && result === "yes"){
    //     this.setDeliveryDate(date);
    //     this.setDeliveryCalendar(delivery_calendar);
    //     this.selected_date = date;
    //    // this.showCalendarDates = false;
    //     this.router.navigate(['/account/orders']);
    //   }
    // });
  }

  getUserDetails() {
    this.apiService.getAutheticatedUserDetails().subscribe(data => {
      if (data['response']['status'] === 1) {
        this.userDetails = data['response']['data']['users'];
        this.deliveryPreference = this.userDetails['delivery_preference'];
        if (this.userDetails['delivery_preference'].toLowerCase() == "pickup") {
          this.deliveryPreference = this.userDetails['delivery_preference'];
        }
      this.deliveryDate = data['response']['data']['delivery_date'] ? data['response']['data']['delivery_date'] : "";
      this.deliveryDate = this.deliveryDate ? this.deliveryDate : sessionStorage.getItem('selected_delivery_date');
        this.setDeliveryDate(this.deliveryDate);
      }
      var bookingStartDate = data['response']['data']['booking_start_date'];
      sessionStorage.setItem('booking_start_date', JSON.stringify(bookingStartDate));
    }, err => { })
  }

  getDeliveryCalendarData(requestParams = null) {
    let params = null;
    if(!!requestParams) {
      params = requestParams;
    }else {
      let selectedDeliveryDate = sessionStorage.getItem('selected_delivery_date');
      if(!!selectedDeliveryDate) {
        let date = moment(selectedDeliveryDate);
        params = {
          isFirst:"false", 
          state: "next",
          year: date.year(),
          starting_date: date.format('YYYY-MM-DD')
        };
      }else {
        params = {isFirst:'true', state: 'next'};
      }
    }
    if(!!params)
      this.getDeliveryCalendar(params);
      this.getDeliveryDates();
  }

  getDeliveryCalendar(last: Object) {
    this.apiService.getDeliveryCalandar({...last}).subscribe(data => {
      if(data['response']['status'] == 1) {
        let resData = data['response']['data']['deliveryCalendar'];
        
        let isInit = !!resData['selected_date'];
        let selectedDate = sessionStorage.getItem('selected_delivery_date');
        let delivery_date = !!selectedDate ? selectedDate : !!resData['selected_date'] ? resData['selected_date'] : null;
        
        let delivery_calendar = null;
        !!delivery_date && resData['weeks'].forEach(date => date['delivery_date'] === delivery_date ? delivery_calendar = date : null);        
        this.disable_prev = resData['last'] && resData['last']['prev_btn_disabled'] ? true : false; 
        this.disable_next = resData['last'] && resData['last']['next_btn_disabled'] ? true : false; 
        this.calendar_data_weeks = resData['weeks'];
        this.calendar_data_last = resData['last'];
        sessionStorage.setItem('calendar_data_last', JSON.stringify(this.calendar_data_last));

        let current_date = moment();
        this.calendar_data_weeks && this.calendar_data_weeks.forEach((date: Object) => {
          let compare_date = moment(date['delivery_date']);
          if(this.calendar_data_last && this.calendar_data_last['type'] === "Weekly" 
            && current_date.week() === compare_date.week()) {
            date['current'] = true;
          }else if(this.calendar_data_last && this.calendar_data_last['type'] === "Daily" 
            && current_date.format('YYYY-MM-DD') === compare_date.format('YYYY-MM-DD')) {
            date['current'] = true;
          }
        });

        this.setSelectedWeekAndDate(delivery_date, delivery_calendar, isInit);
      }else if(data['response'].status === 2 || data['response'].status === 3) {
        displayErrorMessage({
          notification: this.notification, 
          response: data['response']
        });
      }
    }, err => console.error(err))
  }
  getDeliveryDates() {
      // this.sharedDataService.getDeliveryData();
    // this.apiService.getDeliveryDates({}).subscribe((data:any) => {
    //   console.log(data);      
    //   if(data['response']['status'] == 1) {
    //     let eventDates = data['response']['data']['upcoming_event_dates'];
    //     let frequencies = data['response']['data']['frequency'];
    //   // sessionStorage.setItem('upcoming_event_dates', JSON.stringify(eventDates));
    //   // sessionStorage.setItem('recurring_frequencies', JSON.stringify(frequencies));
    //   }else if(data['response'].status === 2 || data['response'].status === 3) {
    //     displayErrorMessage({
    //       notification: this.notification, 
    //       response: data['response']
    //     });
    //   }
    // }, err => console.error(err))
  }

  setSelectedWeekAndDate(date, delivery_calendar, change) {
    if(change) {
      if(this.showCalendarDates && this.router.url !== "/account/orders") {
        let latsSelectedDate = sessionStorage.getItem('selected_delivery_date');
        const dialogRef = this.dialog.open(PopupComponent, {
          maxWidth: '90vw',
          width: '360px',
          data: {
            msg: 'change delivery date',
            previousDate: latsSelectedDate,
            calendar: delivery_calendar
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if(result && result === "yes"){
            this.sharedDataService.cartDataSource.next(false);
            this.setDeliveryDate(date);
            this.setDeliveryCalendar(delivery_calendar);
            this.selected_date = date;
           // this.showCalendarDates = false;
            this.router.navigate(['/account/orders']);
          }
        });
      }else {
        this.setDeliveryDate(date);
        this.setDeliveryCalendar(delivery_calendar);
        this.selected_date = date;
        this.subscription.subjectNext({value: 'Get order'});
      }
    }else {
      this.setDeliveryDate(date);
      this.setDeliveryCalendar(delivery_calendar);
      this.selected_date = date;
    }
  }

  setDeliveryCalendar(deliveryCalendar) {    
    if(!!deliveryCalendar){
      sessionStorage.setItem('selected_delivery_calendar', JSON.stringify(deliveryCalendar));
      sessionStorage.setItem('recurring_frequency', JSON.stringify(deliveryCalendar['product_recurring_frequency']));
      sessionStorage.setItem('booking_start_date',JSON.stringify(deliveryCalendar['booking_start_date']));
    }else{
      sessionStorage.setItem('recurring_frequency', JSON.stringify(['One Time Only']));
    }
  }
  setDeliveryDate(deliveryDate) {
    if(!!deliveryDate)
      sessionStorage.setItem('selected_delivery_date', deliveryDate);
  }

  changeDeliveryDate(data: Object) {
    let selectedDate = sessionStorage.getItem('selected_delivery_date');
    if(data['delivery_date'] !== selectedDate)
      this.setSelectedWeekAndDate(data['delivery_date'], data, true);    
  }

  changeCalendar(last: Object, action: String) { 
  // if(last['state'] != action) {
     let date = moment(last['starting_date']);
    // date.format('YYYY-MM-DD')
     if(action == "next") {
       // if(this.disable_prev)
       //   last['starting_date'] = date.add(1, 'weeks').format('YYYY-MM-DD');
       // else
       //   last['starting_date'] = date.add(8, 'weeks').format('YYYY-MM-DD');
       last['starting_date'] =  this.calendar_data_weeks[this.calendar_data_weeks.length - 1]['delivery_date'];
     }
    else if(action == "prev") {
       last['starting_date'] =  this.calendar_data_weeks[0]['delivery_date'];
     // last['starting_date'] = date.subtract(56, 'days').format('YYYY-MM-DD');
     }
  // }
   last['state'] = action;
   last['isFirst'] = 'false';
   this.getDeliveryCalendarData(last);
 }

  showCalendar() {
    let product_url = this.router.url.split('/');
    if(this.showCalendarUrls.includes(this.router.url) || (product_url[1] === "categories" && product_url.length > 2) || this.router.url.includes('products')) {
      return true;
    }
    return false;
  }

  setDeliveryCalendarOrderStatus(status: string) {
    let selectedDate = sessionStorage.getItem('selected_delivery_date');
    !!this.calendar_data_weeks && this.calendar_data_weeks.forEach(data => {
      if(data['delivery_date'] === selectedDate) {
        switch (status) {
          case 'undelivered':
            data['sale_orders'].push(status);
            break;
          case 'cancelled':
            let orderStatusArr = data['sale_orders'];
            const index = orderStatusArr.findIndex(orderStatus => orderStatus === 'undelivered')
            index >= 0 ? orderStatusArr[index] = 'cancelled': orderStatusArr.length === 0 ? orderStatusArr.push('cancelled') : orderStatusArr[orderStatusArr.length - 1] = 'cancelled';
            break;
        
          default:
            break;
        }
        sessionStorage.setItem('selected_delivery_calendar', JSON.stringify(data));
      }
    })
  }

  ngDoCheck() {
    if(this.previousUrl !== this.router.url) {
      //this.showCalendarDates = false;
      this.getDeliveryCalendarData();
      this.previousUrl = this.router.url;
    }
  }

}